import React, { ReactElement } from 'react';

type Props = {
  action: () => void,
  className: string,
  children: React.ReactNode,
  role: string,
  disabled?: boolean,
  type?: 'button' | 'submit' | 'reset' | undefined
};

export default function Button({
  action, children, role, className, disabled, type,
}: Props): ReactElement {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        action();
      }}
      role={role} className={className}
    >
      {children}
    </button>
  );
}
